// @flow

import React from 'react';
import { useSelector } from 'react-redux';
import LinearProgress from '@mui/material/LinearProgress';
import { selectIsAppLoading, selectLoadingModules } from 'src/reduxStore/modules/common';

const AppLoadingSpinner = () => {
  // Get loading states from Redux store using selectors
  const isAppLoading = useSelector(selectIsAppLoading);
  const loadingModule = useSelector(selectLoadingModules);

  const reducer = (isLoading, moduleKey) => !isLoading ? loadingModule[moduleKey] : true;

  return (
    <>
      {
        isAppLoading
        || (loadingModule && Object.keys(loadingModule).reduce(reducer, false))
        ? <LinearProgress />
        : null
      }
    </>
  );
};

export default AppLoadingSpinner;
